import { FileCheck } from 'lucide-react';
import * as React from 'react';

import type { DiscriminatedMatterRetainerSignedEvent } from '@/services/api/generated/taskActivityService';

import { EventBody, EventContainer, EventHeader } from './EventPrimitives';

interface MatterRetainerSignedEventProps {
  event: DiscriminatedMatterRetainerSignedEvent;
  matterId: string;
}

export const MatterRetainerSignedEvent: React.FC<
  MatterRetainerSignedEventProps
> = ({ event, matterId }) => {
  const { payload, occurred_at, user, agent } = event;
  const { matter } = payload;

  return (
    <EventContainer>
      <EventHeader
        icon={<FileCheck size={20} />}
        title="Retainer Agreement Signed"
        timestamp={occurred_at}
        actor={user}
        agent={agent}
      />

      <EventBody>
        <div className="text-xs text-slate-700">
          The retainer agreement for{' '}
          <span className="font-medium">{matter.name}</span> has been fully
          executed.
        </div>
      </EventBody>
    </EventContainer>
  );
};
